import { AppointmentTimeSlotPlanCreate } from "@/pages/admin/appointment-time-slots/plans/AppointmentTimeSlotPlanCreate";
import { AppointmentTimeSlotPlanDetail } from "@/pages/admin/appointment-time-slots/plans/AppointmentTimeSlotPlanDetail";
import { AppointmentTimeSlotPlanEdit } from "@/pages/admin/appointment-time-slots/plans/AppointmentTimeSlotPlanEdit";
import { AppointmentTimeSlotPlansList } from "@/pages/admin/appointment-time-slots/plans/AppointmentTimeSlotPlansList";
import { RouteObject } from "react-router-dom";

export const appointmentTimeSlotsRoutes: RouteObject[] = [
  {
    id: "appointment-time-slot-plans-list",
    path: "plans",
    element: <AppointmentTimeSlotPlansList />,
  },
  {
    id: "appointment-time-slot-plan-detail",
    path: "plans/:id",
    element: <AppointmentTimeSlotPlanDetail />,
  },
  {
    id: "appointment-time-slot-plan-create",
    path: "plans/create",
    element: <AppointmentTimeSlotPlanCreate />,
  },
  {
    id: "appointment-time-slot-plan-edit",
    path: "plans/:id/edit",
    element: <AppointmentTimeSlotPlanEdit />,
  },
];
